package com.milta.feature.packagelabelscan.data.remote

import com.milta.core.network.ApiException
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.packagelabelscan.data.remote.dto.PackageLabelScanResultDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.forms.formData
import io.ktor.client.request.forms.submitFormWithBinaryData
import io.ktor.client.statement.HttpResponse
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess

class PackageLabelScanApi(private val client: HttpClient) {

    /**
     * POST /api/v1/package-label-scans — single synchronous multipart upload, one required field
     * `image` (contrat MIL-25, écran B). No session, no `routeId`: the confirmation
     * (`POST /routes/{routeId}/deliveries`) happens separately once the driver has reviewed the fields.
     */
    suspend fun scanLabel(fileBytes: ByteArray, fileName: String): PackageLabelScanResultDto =
        client.submitFormWithBinaryData(
            url = "$baseUrl/${Endpoints.packageLabelScans}",
            formData = formData {
                append(
                    key = "image",
                    value = fileBytes,
                    headers = Headers.build {
                        append(HttpHeaders.ContentDisposition, "filename=\"$fileName\"")
                    },
                )
            },
        ).decodeOrThrow()

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${status.value}"
            throw ApiException(status.value, message)
        }
        return body()
    }
}
